import { gsap, ScrollTrigger } from "../global/gsap";

const initAccordions = (accordionEls) => {
    accordionEls.forEach((accordion) => {
        const trigger = accordion.querySelector(".js-trigger");
        const content = accordion.querySelector(".js-content");

        if (accordion.getAttribute("data-state") === "open") {
            gsap.set(content, { height: "auto", opacity: 1 });
            trigger.setAttribute("aria-expanded", "true");
        }

        trigger.addEventListener("click", () => {
            const isOpening = accordion.getAttribute("data-state") === "closed";

            if (isOpening) {
                accordion.setAttribute("data-state", "open");
                trigger.setAttribute("aria-expanded", "true");
                trigger.setAttribute("data-state", "open");
                content.setAttribute("aria-hidden", "false");
                content.setAttribute("data-state", "open");

                gsap.fromTo(
                    content,
                    { height: 0, opacity: 0 },
                    {
                        height: "auto",
                        opacity: 1,
                        duration: 0.5,
                        ease: "power2.out",
                        onComplete: () => ScrollTrigger.refresh()
                    },
                );
            } else {
                accordion.setAttribute("data-state", "closed");
                trigger.setAttribute("aria-expanded", "false");
                trigger.setAttribute("data-state", "closed");
                content.setAttribute("aria-hidden", "true");
                content.setAttribute("data-state", "closed");

                gsap.to(content, {
                    height: 0,
                    opacity: 0,
                    duration: 0.4,
                    ease: "power2.inOut",
                    onComplete: () => ScrollTrigger.refresh()
                });
            }
        });
    });
};

export { initAccordions as default };
